import moment from 'moment';

export const daysOld = (date, today) => moment(today).diff(date, 'days');

export const isDaysOld = ({ days, date, pivot }) =>
  daysOld(date, pivot) >= Number(days);
